import * as gxConst from "@/api/http/gx/gxConst";
import { PIN_AD_BASE_URL, UMENG_BASE_URL } from "@/config/config";
import axios from "axios";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { isIos, getLang, getAppVersion } from "@/utils/lodash";
import {
  urlFilterBaseUrlandPath,
  stransformDataToString
} from "../utils/apiHelpers";
import Http from "@/api/http/fetch";
import { sendGXError, sendGXSuccess } from "@/utils/analytics";
const CryptoJS = require("crypto-js"); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("9vApxLk5G3PAsJrM");
const sendEventKey = CryptoJS.enc.Utf8.parse("8kLmxDP9I5LsBqLou");
const iv = CryptoJS.enc.Utf8.parse("FnJL7EDzjqWjcaY9");

export const cryptoHttp = axios.create();
/**
 * 处理返回的加密
 * @param {*} response
 */
export const resolveGxResult = (word: any) => {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

export const cryptoBodyOrParams = (word: string, request: any) => {
  let sendKey: any;
  if (request.url.indexOf("umeng") !== -1) {
    sendKey = sendEventKey;
  } else {
    sendKey = key;
  }
  console.log("HmacSHA512", CryptoJS.HmacSHA512(word, sendKey).toString());
  return CryptoJS.HmacSHA512(word, sendKey).toString();
};

export const splitHostAndName = (str: any) => {
  let index = str.indexOf("/");
  for (let i = 0; i < 2; i++) {
    index = str.indexOf("/", index + 1);
  }
  return {
    host: str.slice(0, index),
    url_name: str.slice(index)
  };
};

export const signHeadersStringFactory = (request: any) => {
  let { url, baseURL } = request;
  const { method, params, data } = request;
  let joinPrams = "";
  let splitUrl = "";
  if (method === "get") {
    //取出params
    splitUrl = stransformDataToString(params);
  } else {
    const { host, url_name } = splitHostAndName(url);
    baseURL = host;
    url = url_name;
    // splitUrl = stransformDataToString(data);
    splitUrl = JSON.stringify(data);
  }

  joinPrams += `${method.toUpperCase()}&${baseURL}&${url}&${splitUrl}`;

  console.log("signHeadersStringFactory:", joinPrams);
  return joinPrams;
};

//请求的拦截器
cryptoHttp.interceptors.request.use(
  (request: any) => {
    console.info("interceptors request:", request);
    request.headers["Websame-Signature"] = cryptoBodyOrParams(
      signHeadersStringFactory(request),
      request
    );
    return request;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

//response的拦截器
cryptoHttp.interceptors.response.use(
  (response: any) => {
    console.info("interceptors response:", response);
    if (response.status === 200) {
      if (response.config && response.config.method === "post") {
        return response.data;
      } else {
        return {
          ...response,
          data: JSON.parse(resolveGxResult(response.data))
        };
      }
    }
    return response;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

/**
 * PinAd Pure Super Pay
 */
export const getPureSuperPayConfig = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const platform = isIos() ? 1 : 2;
      let device_id: string = "";
      if (store && store.getters[types.GETTER_DEVICE_ID]) {
        device_id = store.getters[types.GETTER_DEVICE_ID];
      }
      const result = await cryptoHttp.request({
        url: gxConst.pureSuperPayConfig,
        disableEncode: true,
        method: "GET",
        params: {
          persistId: device_id,
          deviceId: device_id,
          platform
        },
        baseURL: PIN_AD_BASE_URL
      });
      console.log("getPureSuperPayConfig result:", result);
      sendGXSuccess("getPureSuperPayConfig");
      if (result.data && result.data.data) {
        resolve(result.data.data);
      } else {
        reject(result);
      }
    } catch (error) {
      console.log("getPureSuperPayConfig error:", error);
      sendGXError(error, "getPureSuperPayConfig");
      reject(error);
    }
  });
};

const databaseSendEventArray: any = [
  "uia_recommend_app_installed",
  "uia_order_recommend_offer_buy",
  "uia_start_recommend_buy",
  "uia_arrive_page_offer_buy",
  "uia_feed0_coins_buy",
  "uia_feed1_coins_buy",
  "uia_feed2_coins_buy",
  "te"
];

/*
* umeng point interface
* */
export const umengNativePoint = async (param: any) => {
  try {
    const AppInfo: any = await Http.AppInfo();
    const { event_id } = param;
    let { event_key, event_value } = param;
    if (!databaseSendEventArray.includes(event_id)) {
      return;
    }
    if (!isNaN(event_key)) {
      event_key = event_key.toString();
    }
    if (!isNaN(event_value)) {
      event_value = event_value.toString();
    }
    const platform = AppInfo.GETX_PLATFORM;
    let device_id: string = "";
    if (store && store.getters[types.GETTER_DEVICE_ID]) {
      device_id = store.getters[types.GETTER_DEVICE_ID];
    }
    const result = await cryptoHttp.post(
      UMENG_BASE_URL + gxConst.sendEventConfig,
      {
        event_id,
        event_key,
        event_value,
        timestamp: new Date().getTime().toString(),
        alias_type: platform,
        alias: device_id
      }
    );
    sendGXSuccess("umengNativePoint");
  } catch (error) {
    sendGXError(error, "umengNativePoint");
  }
};
